/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSavePaymentMethodResponseFromDiscriminatorValue, serializeSavePaymentMethodRequest, serializeSavePaymentMethodResponse, type ErrorResponse, type InternalErrorResponse, type SavePaymentMethodRequest, type SavePaymentMethodResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/payment-methods
 */
export interface PaymentMethodsRequestBuilder extends BaseRequestBuilder<PaymentMethodsRequestBuilder> {
    /**
     * Save a credit card payment method using the configured payment provider for the organization. For hosted payment flows (WorldPay), returns a redirect URL.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SavePaymentMethodResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SavePaymentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SavePaymentMethodResponse | undefined>;
    /**
     * Save a credit card payment method using the configured payment provider for the organization. For hosted payment flows (WorldPay), returns a redirect URL.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SavePaymentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PaymentMethodsRequestBuilderUriTemplate = "{+baseurl}/api/payments/payment-methods";
/**
 * Metadata for all the requests in the request builder.
 */
export const PaymentMethodsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PaymentMethodsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSavePaymentMethodResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSavePaymentMethodRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
